/**************************************************
 * Nombre:       Seccion_Mixlrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useParams} from "react-router-dom";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import Tarjeta_Mixlrs from "../Tarjetas/Tarjeta_Mixlrs";
import useRecuperarColleccionListeningProg from "../../Servicios/BD/useRecuperarColleccionListeningProg";


const Seccion_Mixlrs = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [wheres, setWhers] = useState([])
    const {data, cargarMas} = useRecuperarColleccionListeningProg({col: 'mixlrs', wheres: wheres, direccion: 'desc'})
    const [idEscogido, setIdEscogido] = useState('');


    useEffect(() => {

        if (parms && parms.id) {
            setIdEscogido(parms.id);
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
                onLoad={() => {

                    if (idEscogido) {
                        scrolearAComponente(idEscogido)
                    }

                }
                }
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Mixlrs
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Sintoniza nuestros programas en Mixlr y descubre conversaciones inspiradoras,
                                        historias reales y aprendizajes que impulsan tu crecimiento personal y
                                        profesional.
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', mt: 8, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        {data.map((it, index) => (
                            <Grid id={it.id} container size={{xs: 12, sm: 6, md: 6}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Mixlrs escogida={idEscogido} item={it}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Mixlrs


